
import React from 'react';

import { handleParmas, getUrlParams } from './utils';


const dataStatistics = (options, event_key, json) => {
  let userInfo = localStorage.getItem('userInfo');
  if (userInfo) {
    userInfo = JSON.parse(userInfo);
  }

  let page_param = getUrlParams() || {};

  try {
    if (json.page_param) {
      page_param = {
        ...page_param,
        download_ids: json.page_param.downloadIds,
      };
    }
  } catch (e) {}

  try {
    if (json.params) {
      page_param = {
        ...page_param,
        ...json.params,
      };
    }
  } catch (e) {}

  let _keywords = '';
  try {
    if (json.keywords) {
      _keywords = json.keywords || [];
      if (_keywords.length > 0) {
        console.log('_keywords', _keywords);
        _keywords = _keywords.map((item) => item.tag_id);
      } else {
        _keywords = '';
      }
    }
  } catch (e) {}

  // 页面标题
  let _page_title = window.document.title || '';

  // 事件类型
  let event_type = '';
  if (typeof options == 'object') {
    event_type = options.event_type || '';
    _page_title = options.page_title || _page_title;
  } else {
    event_type = options;
  }

  if (typeof _keywords === 'object') {
    _keywords = JSON.stringify(_keywords)
  }

  let params = {
    type: 1,
    user_id: userInfo ? userInfo.id : '',
    unionid: userInfo ? userInfo.unionid : '',
    openid: localStorage.getItem('openid'),
    page_title: _page_title,
    keywords: _keywords || undefined,
    page_description: undefined,
    page_url: encodeURIComponent(window.location.href),
    page_referer_url: undefined,
    page_param,
    page_event_key: event_key || undefined, // 当是点击事件的时候，这里需要传点击按钮的文案。
    page_event_type: event_type || 'view', // view = 浏览  click = 点击   share = 分享
    wechat_user_name: "GLG",
    wechat_appid: "wx5368b9721507e008",
    token:"88d65b51560de531",
  };


  React.$request("https://middle-platform.blue-dot.cn/api/platform/analysis/monitor", {
    method: 'get',
    params: handleParmas(params),
  }).then(() => { });


};


export {dataStatistics };
